
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.2567 2.72315C11.5609 2.42562 12.0542 2.42562 12.3585 2.72315L20.2718 10.4612C20.4179 10.6041 20.5 10.7979 20.5 11C20.5 11.2021 20.4179 11.3958 20.2718 11.5387L12.3585 19.2768C12.0542 19.5744 11.5609 19.5744 11.2567 19.2768C10.9524 18.9793 10.9524 18.4969 11.2567 18.1993L17.8399 11.7619H1.27914C0.848833 11.7619 0.5 11.4208 0.5 11C0.5 10.5792 0.848833 10.2381 1.27914 10.2381H17.8399L11.2567 3.80063C10.9524 3.50309 10.9524 3.02069 11.2567 2.72315Z","fill":"#8338EC"}})])
          )
        }
      }
    